import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Link } from "react-router-dom";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import { DataGrid, GridColDef, GridOverlay, GridColParams, GridCellParams, GridPageChangeParams, GridSelectionModelChangeParams, GridBaseComponentProps, GridSortModelParams } from '@material-ui/data-grid';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import GpsNotFixedIcon from '@material-ui/icons/GpsNotFixed';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import SettingsIcon from '@material-ui/icons/Settings';
import './MassMessage.scss'
import { IGraduateTable } from '../../interfaces/IGraduateTable';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { containsAny } from '../../helpers/sharedFunctions';
import { IScheduleMessage } from '../../interfaces/IScheduleMessage';
import { permissionAdminModifyNewEvent } from '../../utils/PermissionsVariables';
import UserContext from '../../utils/UserContext';

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 14,
            padding: '5px 6px 10px 12px',
            height: '30px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
        },
    }),
)(InputBase);

interface DataTableGraduateProps {
    rows: Array<IScheduleMessage>;
    pageSize: number;
    onChanhePageSize: any;
    initPage: number;
    setInitPage: any;
    setCurrentPage: any;
    onSortedRows?: any;
    handleUpdate: any;
    deleteModal: any;
}

const MassMessageTable: React.FC<DataTableGraduateProps> = ({ rows, pageSize, onChanhePageSize, initPage, setInitPage, setCurrentPage, onSortedRows, handleUpdate, deleteModal }) => {

    const userContext = React.useContext(UserContext);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [rowSelected, setRowSelected] = useState<IScheduleMessage>(new IScheduleMessage());

    const columnsGraduate: GridColDef[] = [
        {
            field: 'subject', valueGetter: (params: GridCellParams) => params.row.emailData?.subject || '',
            headerName: 'Asunto', width: 600, renderHeader: (params: GridColParams) => (
                <strong className="column-states">
                    <span className="column-header-title">
                        {'Asunto'}
                    </span>
                    <UnfoldMoreIcon fontSize="small" className="color-arrows" />
                </strong>
            ),
            renderCell: (params: GridCellParams) => {
                const subject = params.row.emailData?.subject || '';
                return (
                    <span className="name-cell">{subject}</span>
                );
            }   
        },
        {
            field: 'eventDate', headerName: 'Fecha', width: 300, renderHeader: (params: GridColParams) => (
                <strong className="column-states">
                    <span className="column-header-break">
                        Fecha del envio
                    </span>
                    <UnfoldMoreIcon fontSize="small" className="color-arrows" />
                </strong>
            ), renderCell: (params: GridCellParams) => {
                const valueDate = moment((params.value)?.toString()).format('DD/MM/YYYY hh:mm a');
                return (
                    <span className="date-cell">{valueDate}</span>
                )
            }
        },
        {
            field: 'Acción', headerName: 'Acciones', width: 150, sortable: false, renderHeader: (params: GridColParams) => (
                <strong className="column-states">
                    <span className="column-header-title">
                        {'Acciones'}
                    </span>
                </strong>
            ), renderCell: (params: GridCellParams) => (
                <>
                    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={(e) => handleClick(e, params)}>
                        <SettingsIcon />
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleCloseMenu}
                    >
                        {containsAny(permissionAdminModifyNewEvent, userContext.userPermissions) &&
                            <MenuItem onClick={(e) => { handleCloseMenu(); handleUpdate('Edit', rowSelected.ruleName) }}>
                                Editar
                            </MenuItem>
                        }
                        {
                            <MenuItem onClick={(e) => { handleCloseMenu(); deleteModal(rowSelected) }}>
                                Eliminar
                            </MenuItem>
                        }
                    </Menu>
                </>
            )
        },
    ];

    const handlePage = (pageParams: GridPageChangeParams) => {
        setPageNumber(pageParams.page);
        setCurrentPage(pageParams.page + 1);
        setInitPage(1);
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>, params: GridCellParams) => {
        setAnchorEl(event.currentTarget);
        const user: IScheduleMessage = Object.assign(params.row);
        setRowSelected(user)
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };


    return (
        <Grid container className="data-grid-container">
            <Grid item xs={12}>
                <DataGrid autoHeight className="data-grid-list" disableColumnMenu rows={rows} getRowId={(row) => row.ruleName} columns={columnsGraduate} pageSize={pageSize} pagination density="compact" disableSelectionOnClick onPageChange={(params: GridPageChangeParams) => handlePage(params)} onSortModelChange={(params: GridSortModelParams) => onSortedRows(params)}
                    components={{
                        NoRowsOverlay: CustomNoRowsOverlay,
                        ColumnSortedAscendingIcon: customSortAsc,
                        ColumnSortedDescendingIcon: customSortDesc,
                        Footer: (props) => CustomFooter(props, initPage, onChanhePageSize, pageSize)
                    }}
                />
            </Grid>
        </Grid>
    );
}

const CustomFooter = (props: GridBaseComponentProps, initPage: number, onChanhePageSize?: any, valueRows?: number) => {
    const { state, api } = props;
    const rowsPerPageOptions = [5, 10, 25, 50, 100];

    useEffect(() => {
        if (initPage === 0) {
            api.current.setPage(0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initPage]);
    return (
        <>
            <div className="footer-container">
                <div className="rows-number-container">
                    <Typography variant="h5" className="rows-number-text">Mostrar</Typography>

                    <Select
                        id="demo-simple-select"
                        value={valueRows}
                        onChange={onChanhePageSize}
                        input={<BootstrapInput />}
                    >
                        {rowsPerPageOptions.map(item => (
                            <MenuItem value={item}>{item}</MenuItem>
                        ))}
                    </Select>
                    <Typography variant="h5" className="rows-number-text">Registros</Typography>
                </div>
                <Pagination
                    className="pagination-container"
                    color="primary"
                    page={state.pagination.page + 1}
                    count={state.pagination.pageCount}
                    onChange={(event, value) => api.current.setPage(value - 1)}
                    showFirstButton
                    showLastButton
                />
            </div>
        </>
    );
}

const CustomNoRowsOverlay = () => {
    return (
        <GridOverlay className="not-result-list">
            <GpsNotFixedIcon fontSize="large" />
            <Typography variant="h4" className="not-results-text">
                Sin registros
            </Typography>
        </GridOverlay>
    );
}

const customSortAsc = (props: GridBaseComponentProps) => <KeyboardArrowUpIcon fontSize="small" />
const customSortDesc = (props: GridBaseComponentProps) => <KeyboardArrowDownIcon fontSize="small" />

export default MassMessageTable;